// One labelled input. Always a real <label> tied to the input by id, never a
// placeholder standing in for one: a placeholder disappears the moment somebody
// types, and it is not announced as a label.

export default function Field({ id, label, hint, error, ...input }) {
  return (
    <div>
      <label htmlFor={id} className="block text-[15px] font-semibold text-ink">{label}</label>
      {hint && <p className="mt-1 text-[14px] text-ink-muted">{hint}</p>}
      <input
        id={id}
        className={`mt-2 w-full rounded-field border bg-surface px-4 py-3.5 text-[17px] text-ink outline-none transition-colors placeholder:text-ink-muted/60 ${
          error ? 'border-danger' : 'border-hairline focus:border-action'
        }`}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={error ? `${id}-error` : undefined}
        {...input}
      />
      {error && (
        <p id={`${id}-error`} className="mt-2 text-[15px] text-danger">{error}</p>
      )}
    </div>
  )
}
